var _path, _circle, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconSuccess = function SvgIconSuccess(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#20B26C",
    fillOpacity: 0.12,
    d: "M20 5C11.714 5 5 11.716 5 20s6.715 15 15 15 15-6.716 15-15S28.283 5 20 5M1.665 20c0-10.125 8.208-18.333 18.333-18.333 10.126 0 18.334 8.208 18.334 18.333s-8.208 18.333-18.334 18.333S1.666 30.125 1.666 20"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.999,
    cy: 20,
    r: 18.333,
    fill: "#20B26C",
    fillOpacity: 0.12
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#20B26C",
    d: "M28.664 14.64c.66.643.673 1.698.03 2.357l-9.738 9.988c-.644.66-1.7.68-2.367.044l-5.238-4.989a1.667 1.667 0 1 1 2.3-2.413l4.056 3.864 8.6-8.821a1.667 1.667 0 0 1 2.357-.03"
  })));
};
export default SvgIconSuccess;